import React from 'react';

import {connect} from "react-redux";
import Loader from "../common/Loader";
import sematable, {Table} from "sematable";
import l10n from "../../l10n/localization";
import * as commodityActions from "../../actions/commodity";
import CommodityForm from "../forms/CommodityForm";
import {Button,NavItem} from "react-materialize";
import * as creationActions from "../../actions/creation";
import * as commoditiesActions from "../../actions/commodity";
import Dropdown from "../common/Dropdown";
import Dialog from "react-toolbox/lib/dialog/Dialog";

export const COMMODITIES_TABLE = 'COMMODITIES_TABLE';

const columns = [
    { key: 'id', header: 'ID', primaryKey: true, hidden: true},
    { key: 'name', header: l10n.commodities.name, searchable: true, filterable: true, sortable: true},
    { key: 'commodityGroupName', header: l10n.commodities.commodityGroupName, searchable: true, filterable: true, sortable: true},
    { key: 'actions', header: ''}
];

/**
 * Table
 */
class CommoditiesTable extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            commoditiesID: null,
            dialogActive: false
        };
    }

    handleDelete = () => {
        this.props.dispatch(commoditiesActions.deleteCommodities(this.state.commoditiesID));
    };

    addActions() {
        this.props.columns[this.props.columns.length - 1].Component = ({row}) => {
            return (
                <div className="fog-table-buttons commodities-button">
                    {<Dropdown trigger={(props) => (
                        <Button floating icon="more_vert" className="more-button" onClick={props.onClick}/>)}>
                        <NavItem>
                            <Button disabled={this.props.deletingCommodities} className="transparent" onClick={() => this.setState({...this.state, dialogActive: true, commoditiesID: row.id})} >
                                {l10n.common.remove}
                            </Button>
                        </NavItem>
                    </Dropdown>}
                    <Button floating onClick={() => this.props.handleClick(CommodityForm, {item: row}, creationActions.destroyingnewlyCreatedCommodity())} icon="edit" className="edit-button" />
                </div>
            )
        };
    }

    render() {
        this.addActions();

        return (
            <div>
                <Table  {...this.props} data={this.props.data} />
                <Dialog
                    actions={[
                        { label: "Cancel", onClick: () => this.setState({...this.state, dialogActive: false, commoditiesID: null}) },
                        { label: "Yes", onClick: () => this.handleDelete() }
                    ]}
                    active={this.state.dialogActive}
                    title='Confirmation'>
                    <p>Are you sure you want to delete this commodity ?</p>
                </Dialog>
            </div>
        )
    }
}

let CommoditiesTableSematable = sematable(COMMODITIES_TABLE, CommoditiesTable, columns, {
    defaultPageSize: -1,
    autoHidePagination: true,
    showPageSize: false
});

/**
 * Wrapper
 */
class Commodities extends React.Component {

    componentDidMount() {
        this.props.dispatch(commodityActions.fetchCommodities(true));
    }

    render() {
        if (this.props.loading || this.props.commodities === undefined) {
            return (<div><Loader/></div>)
        }

        return (
            <div>
                <h1>{this.props.item.title}</h1>
                <Button type="button" floating onClick={() => this.props.handleClick(CommodityForm, {item: null, selectNewItem: false}, creationActions.destroyingnewlyCreatedCommodity())} icon="add" className="add-button"/>
                <CommoditiesTableSematable {...this.props} data={this.props.commodities} />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        commodities: state.commodity.commodities,
        loading: state.commodity.loading,
        deletingCommodities: state.commodity.deleting
    });
})(Commodities);


// WEBPACK FOOTER //
// ./src/components/prefTables/Commodities.js